import styled, { keyframes } from "styled-components";

// 애니메이션
export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

// 메인 컨테이너
export const HomeContainer = styled.div`
  padding: 32px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  color: #333;
`;

export const WelcomeSection = styled.div`
  text-align: center;
  margin-bottom: 48px;
  animation: ${fadeInUp} 1s ease-out;
`;

export const MainTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const SubTitle = styled.p`
  font-size: 1.3rem;
  color: #64748b;
  margin-bottom: 24px;
  font-weight: 500;
`;

export const CurrentTime = styled.div`
  font-size: 1.2rem;
  color: #475569;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.7);
  padding: 12px 24px;
  border-radius: 25px;
  display: inline-block;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

// 카드 그리드
export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  @media (min-width: 1201px) and (max-width: 1600px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Card = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #333;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeInUp} 0.8s ease-out;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #667eea, #764ba2);
  }

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 32px 64px -12px rgba(0, 0, 0, 0.15),
      0 25px 32px -8px rgba(0, 0, 0, 0.08);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
`;

export const CardIcon = styled.div`
  font-size: 2.5rem;
  margin-right: 16px;
  animation: ${float} 3s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
`;

export const CardTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.5px;
`;

// 공지사항 스타일
export const NoticeList = styled.div`
  max-height: 350px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(241, 245, 249, 0.5);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea, #764ba2);
    border-radius: 4px;

    &:hover {
      background: linear-gradient(135deg, #5a67d8, #6b46c1);
    }
  }
`;

export const NoticeItem = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer; // 👈 이미 있지만 확인
  transition: all 0.3s ease;
  animation: ${slideIn} 0.5s ease-out;

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(103, 126, 234, 0.05),
      rgba(118, 75, 162, 0.05)
    );
  }

  &:active {
    transform: translateX(2px) scale(0.98); // 👈 클릭 효과 추가
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const NoticeTitle = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
  color: #1e293b;
  font-size: 1.1rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const NoticeDate = styled.div`
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
`;

export const NewBadge = styled.span`
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 8px;
  margin-right: 8px;
  animation: ${float} 2s ease-in-out infinite;
`;

// 팀멤버 스타일
export const MemberGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const MemberCard = styled.div`
  background: linear-gradient(135deg, #667eea, #764ba2);
  padding: 20px;
  border-radius: 16px;
  color: white;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer; // 👈 추가

  &:hover {
    transform: scale(1.05) rotate(1deg);
    box-shadow: 0 12px 24px rgba(103, 126, 234, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const MemberName = styled.div`
  font-weight: 700;
  margin-bottom: 4px;
  font-size: 1.1rem;
`;

export const MemberTel = styled.div`
  font-size: 0.85rem;
  opacity: 0.9;
`;

export const OnlineStatus = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #10b981;
  display: inline-block;
  margin-left: 8px;
  animation: ${float} 1.5s ease-in-out infinite;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.5);
`;

// 캘린더 스타일
export const CalendarContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
`;

export const EventItem = styled.div`
  background: linear-gradient(
    135deg,
    rgba(103, 126, 234, 0.1),
    rgba(118, 75, 162, 0.1)
  );
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  border-left: 4px solid;
  border-left-color: "#667eea";
  transition: all 0.3s ease;
  animation: ${slideIn} 0.5s ease-out;

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

export const EventTime = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 4px;
`;

export const EventTitle = styled.div`
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  font-size: 1.1rem;
`;

export const EventDescription = styled.div`
  font-size: 0.9rem;
  color: #64748b;
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 40px;
  color: #64748b;
`;

// 팀멤버 모달 스타일 추가 (HomePage.style.ts에)
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: ${fadeInUp} 0.3s ease-out;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #64748b;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
`;

export const MemberInfo = styled.div`
  text-align: center;
`;

export const MemberModalAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  margin: 0 auto 20px;
  border: 4px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
`;

export const MemberModalName = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 8px 0;
`;

export const MemberDetail = styled.div`
  background: #f8fafc;
  padding: 16px;
  border-radius: 12px;
  margin: 16px 0;
  text-align: left;
`;

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  color: #475569;
`;

export const DetailValue = styled.span`
  color: #1e293b;
`;
